import { Language } from "../model/Language";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export const fetchLanguages = async (): Promise<Language[]> => {
  const response = await axiosInstance.get<ApiResponse<Language[]>>("/api/language/list");
  const languages = response.data?.data;
  if (!Array.isArray(languages) || languages.length === 0) {
    throw new Error("No languages are available from the server. Extraction cannot start. Please contact an administrator.");
  }
  if (languages.some((language) =>
    !language ||
    typeof language.code !== "string" || !language.code.trim() ||
    typeof language.name !== "string" || !language.name.trim()
  )) {
    throw new Error("The server returned invalid language data. Extraction cannot start. Please contact an administrator.");
  }
  return languages;
};
